@if (view$ | async; as view) {
  <h3 class="h4 bold">{{law.name}}</h3>
  <div class="container" [innerHtml]="view"></div>
} @else {
  <div class="loader-container">
    <static-loader></static-loader>
  </div>
}

